import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { useFrameStore } from './seg-frame-store';
import { WARNING_DIM, TABS, FRAME_COLORS } from './helpers/frameConstants';
import { HangingType } from './helpers/segFrameBuilderTypes';
import BatchCollectionTray from './BatchCollectionTray.vue';
import CostSettingsTable from './CostSettingsTable.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConfigSidebar',
    setup(__props, { expose: __expose }) {
        __expose();
        const store = useFrameStore();
        const showDimensionWarning = computed(() => {
            return store.activeFrame.dims.w > WARNING_DIM && store.activeFrame.dims.h > WARNING_DIM;
        });
        const toggleCostSettings = () => {
            store.showCostSettings = !store.showCostSettings;
        };
        const supportEndClipCount = computed(() => store.activeFrameData?.hw?.supportEndClips ?? 0);
        const hwEntries = computed(() => {
            const hw = store.activeFrameData?.hw;
            if (!hw)
                return [];
            return Object.entries(hw)
                .filter(([key, v]) => key !== 'supportEndClips' && v > 0);
        });
        const formatHWLabel = (key) => key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase());
        const currentStep = computed(() => store.assemblySteps[store.assemblyStep] ?? null);
        const stepBack = () => {
            store.assemblyStep = Math.max(0, store.assemblyStep - 1);
        };
        const stepNext = () => {
            store.assemblyStep = Math.min(store.assemblySteps.length - 1, store.assemblyStep + 1);
        };
        const handleQtyInput = (e) => {
            const target = e.target;
            const rawValue = target.value;
            if (rawValue === '') {
                store.updateQuantity(0);
                return;
            }
            const parsedQuantity = Number(rawValue);
            if (!isNaN(parsedQuantity)) {
                store.updateQuantity(parsedQuantity);
            }
        };
        const __returned__ = { store, showDimensionWarning, toggleCostSettings, supportEndClipCount, hwEntries, formatHWLabel, currentStep, stepBack, stepNext, handleQtyInput, get TABS() { return TABS; }, get FRAME_COLORS() { return FRAME_COLORS; }, get HangingType() { return HangingType; }, BatchCollectionTray, CostSettingsTable };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
